import { t } from 'ttag';
import { setLocale } from 'yup';

setLocale({
    mixed: {
        required: t`Обов'язкове поле`,
        notType: t`Не коректний тип даних`,
        default: t`Невірне значення`,
        notNull: t`Не може бути пустим`,
        defined: t`Не може бути пустим`,
        oneOf: t`Має бути одним з \${values}`,
        notOneOf: t`Не може бути одним з \${values}`,
    },
    number: {
        max: t`Максимальне значення \${max}`,
        min: t`Мінімальне значення \${min}`,
        integer: t`Має бути цілим числом`,
        lessThan: t`Має бути менше ніж \${less}`,
        moreThan: t`Має бути більше ніж \${more}`,
        positive: t`Має бути більше ніж 0`,
        negative: t`Має бути менше ніж 0`,
    },
    string: {
        max: t`Максимальне значення \${max}`,
        min: t`Мінімальне значення \${min}`,
        length: t`Має бути рівним \${length}`,
        email: t`Некоректний email`,
        url: t`Некоректний url`,
        trim: t`Не може містити пробіли на початку та в кінці`,
        lowercase: t`Має бути в нижньому регістрі`,
        uppercase: t`Має бути в верхньому регістрі`,
        uuid: t`Має бути в форматі uuid`,
        matches: t`Не відповідає формату`,
    },
    date: {
        max: t`Має бути менше ніж \${max}`,
        min: t`Має бути більше ніж \${min}`,
    },
});
